module.exports = __webpack_public_path__ + "static/img/icon2.abf3efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon2.png
// module id = HosE
// module chunks = 1